/* eslint-disable array-bracket-newline */
/**
 * Implements a tab title change logic across different pages
 */
import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useTickerLivePrice, {
  LivePrice,
} from '../../components/Watchlist/hooks/useTickerLivePrice';
import useTicker from '../../hooks/useTicker';
import { roundToPrecision } from '../../helpers/truncate';
import { ICurrentState } from './../../reducers/current';
import { IStore } from '../../reducers';

const WALLET_PAGE_PATTERN = '/:lang/wallet-overview/:chain/:address';

/**
 * Updates page title
 * @param current - current ticker
 * @param price - price data object
 */
const onUpdatePageTitle = (
  current: ICurrentState,
  price: LivePrice
): string => {
  const { base, quote } = useTicker(current);

  let title;
  // const sign = res.side == 'Buy' ? '⬆️' : '🔻';
  // Set price quote token
  if (!price.rawPrice) {
    title = `${base}/${quote} ✓ Trade ${base} to ${quote} | Buy ${base} (coin)| livechart on Kattana`;
  } else {
    title = `${base} ${price.sign}${roundToPrecision(
      price.rawPrice,
      true,
      2
    )} ✓ Trade ${base} to ${quote} | Buy ${base} (coin)| livechart on Kattana`;
  }

  return title;
};

const AppTitle = () => {
  const current = useSelector((state: IStore) => state.current);

  const { price } = useTickerLivePrice(current);

  const isWalletPage = useMatch(WALLET_PAGE_PATTERN);

  /**
   * Hook responsible for tab title
   */
  useEffect(() => {
    if (document) {
      let title = '';

      if (isWalletPage) {
        title = 'Magic wallet analyzer';
      } else {
        title = onUpdatePageTitle(current, price);
      }

      if (title) {
        window.requestIdleCallback(() => {
          try {
            document.title = title;
          } catch (err) {
            console.warn('Could not set title due to the error', err);
          }
        });
      }
    }
  }, [current, price, isWalletPage]);

  return null;
};

export default AppTitle;
